export default __webpack_public_path__ + "static/media/welcome-graphic.64ba3392.png";